export type AppConfig = Record<string, unknown>;

const defaultAppConfig: AppConfig = {};

export const appConfig: AppConfig = { ...defaultAppConfig };

export const loadAppConfig = async (): Promise<void> => {
  try {
    const response = await fetch('assets/config.json', { cache: 'no-cache' });

    if (!response.ok) {
      throw new Error(`Unable to load app config. Status: ${response.status}`);
    }

    const config = (await response.json()) as Partial<AppConfig>;
    Object.assign(appConfig, defaultAppConfig, config);
  } catch (error) {
    console.error('Failed to load assets/config.json. Using default app config.', error);
    Object.assign(appConfig, defaultAppConfig);
  }
};
